<template>
  <Modal :title="title" @backdrop-click="close">
    <template slot="body">
      <div class="vert-scroll table-responsive table-responsive_long-list">
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="list__column">
                Название
              </th>
              <th class="list__column">
                Создан
              </th>
              <th class="list__column">
                Дата сдачи
              </th>
              <th class="list__column">
                Ссылка
              </th>
            </tr>
          </thead>
          <tbody class="scroll-table-body">
            <tr v-for="project in projects" :key="project.id">
              <td class="list__row">
                {{ project.name }}
              </td>
              <td class="list__row">
                {{ project.created_at }}
              </td>
              <td class="list__row">
                {{ project.deadline_datetime }}
              </td>
              <td class="list__row">
                <router-link :to="`/projects/${project.id}`" target="_blank">
                  <i class="fa fa-link" />
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template slot="footer">
      <button class="btn btn-primary" @click="close">
        Закрыть
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/_shared/components/ui/Modal";
export default {
  emits: ['close'],
  components: {
    Modal,
  },
  props: {
    withFailedDeadlines: {
      type: Boolean,
      default: false,
    },
    projects: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    title() {
      let text = 'Проекты пользователя';
      if (this.withFailedDeadlines === true) {
        text += ' (просроченные)';
      }
      return text;
    },
  },
  mounted() {
    document.querySelector("body").style.overflow = "hidden";
  },
  methods: {
    close() {
      document.querySelector("body").style.overflow = "auto";
      this.$emit('close');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/user/components/analytics/UserProjectsModal.vue